export const validateEnvironment = () => {
  const requiredVars = [
    'REACT_APP_API_ENDPOINT',
    'REACT_APP_CLOUDFRONT_DOMAIN',
    'REACT_APP_USER_POOL_ID',
    'REACT_APP_CLIENT_ID',
    'REACT_APP_REGION',
    'REACT_APP_IDENTITY_POOL_ID'
  ];

  const missing = requiredVars.filter(varName => !process.env[varName]);
  
  if (missing.length > 0) {
    console.warn(`Warning: Missing environment variables: \${missing.join(', ')}`);
  }
};
